import React, {Component} from 'react';

export default class DashboardDetail extends Component {

    constructor(props) {
        super(props);
    }


    render() {
        let el = this.props.orders[this.props.el];

        return (
            <li className="dashboard-detail-list">
                {this.props.ordersName === "Panoramik Albüm" ? (
                    <span>
                            <strong> {this.props.panoramic[this.props.orderKey]} </strong>
                            <small>
                                {(el === "null") ? "Yok": el }

                            </small>
                        </span>
                ) : (
                    <span hidden> </span>
                )}

                {this.props.ordersName === "Okul Albüm" ? (
                    <span>
                            <strong> {this.props.school[this.props.orderKey]} </strong>
                            <small>
                                {(el === "null") ? "Yok": el }

                            </small>
                        </span>
                ) : (
                    <span hidden> </span>
                )}

                {this.props.ordersName === "Tual" ? (
                    <span>
                            <strong> {this.props.tual[this.props.orderKey]} </strong>
                            <small>
                                {(el === "null") ? "Yok": el }

                            </small>
                        </span>
                ) : (
                    <span hidden> </span>
                )}

                {this.props.ordersName === "Fotoblok" ? (
                    <span>
                            <strong> {this.props.photoblock[this.props.orderKey]} </strong>
                            <small>
                                {(el === "null") ? "Yok": el }

                            </small>
                        </span>
                ) : (
                    <span hidden> </span>
                )}

                {this.props.ordersName === "Baskı" ? (
                    <span>
                            <strong> {this.props.printing[this.props.orderKey]} </strong>
                            <small>
                                {(el === "null") ? "Yok": el }

                            </small>
                        </span>
                ) : (
                    <span hidden> </span>
                )}
            </li>


        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashboard-detail.js